import React from "react";
import { Button, Space } from "antd";
import { useAtom } from "jotai";
import LoginService from "services/LoginService";
import { visibleModalCrearSolicitudAusenciaAtom, visibleModalRecordVacacionalAtom } from "../../ProgramarMovimientosStore";

const BotonesProgramarMovimientos = () => {
	const [, setVisibleModal] = useAtom(visibleModalCrearSolicitudAusenciaAtom);
	const [, setVisibleModalRecordVacacional] = useAtom(visibleModalRecordVacacionalAtom);
	const isSDF = LoginService.getUsuarioAutenticado().empresaSeleccionada?.ruc === "20330791684" ? true : false;
	const isSDFEnergia = LoginService.getUsuarioAutenticado().empresaSeleccionada?.ruc === "20512436090" ? true : false;
	const isManuelita = LoginService.getUsuarioAutenticado().empresaSeleccionada?.ruc === "20411051782" ? true : false;

	return (
		<div style={{ textAlign: "right", marginTop: 5, marginRight: 5 }}>
			<Space>
				<Button type="primary" onClick={() => setVisibleModal(true)}>
					{(isSDF || isSDFEnergia || isManuelita) ? "Solicitar Movimiento":"Solicitar Ausencia"}
				</Button>
			</Space>
		</div>
	);
};

export default BotonesProgramarMovimientos;
